import { Trans, useLingui } from '@lingui/react/macro'
import { Button, Result } from 'antd'
export function E500() {
  const { t } = useLingui()
  return (
    <Result
      className={'h-screen'}
      status="500"
      title="500"
      subTitle={t`Sorry, something went wrong.`}
      extra={
        <div>
          <Button type="primary" onClick={() => window.location.reload()}>
            <Trans>Reload Page</Trans>
          </Button>
        </div>
      }
    />
  )
}
